module.exports = __webpack_public_path__ + "static/8-2ff6d0428d28d1dd19f7e134565139e7.jpg";